module.exports = __webpack_public_path__ + "static/media/MOWA.42941d83.png";